import { FixaResource, LoginData } from '../models/login.model';

/**
 * Reconstrói LoginData a partir da resposta do authPing,
 * preservando UUID e campos de sessão já selecionados.
 */
export function buildLoginDataFromAuthPing(
  response: unknown,
  previousLoginData?: LoginData | null
): LoginData | null {
  const r = response as Record<string, unknown> | null | undefined;
  const document = r?.['document'];
  const companyName = r?.['companyName'];
  const sessionId = r?.['sessionId'];
  const resourcesObj = r?.['resources'] as Record<string, unknown> | null | undefined;
  const contracts = Array.isArray(resourcesObj?.['contracts'])
    ? (resourcesObj['contracts'] as FixaResource[])
    : [];

  if (typeof sessionId !== 'string' || !sessionId) {
    return null;
  }

  const persistedUuid = previousLoginData?.userUuid?.trim() || '';

  return {
    loginAccess: (document ??
      companyName ??
      previousLoginData?.loginAccess ??
      '') as string,
    loginDate: previousLoginData?.loginDate || new Date().toISOString(),
    userUuid: persistedUuid,
    document: (document as string | undefined) || previousLoginData?.document,
    companyName:
      (companyName as string | undefined) || previousLoginData?.companyName,
    sessionId: sessionId as string,
    resources: contracts.length > 0 ? contracts : previousLoginData?.resources,
    lastActivity: previousLoginData?.lastActivity,
    isFirstAccess: previousLoginData?.isFirstAccess,
  };
}
